import React from 'react';
import { Link } from 'react-router-dom';
// 1. Import your downloaded video asset directly from your path folder
import heroVideo from '../assets/videos/videos5.mp4'; 

function HeroSection() {
  return (
    <div style={{
      position: 'relative',
      height: '85vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      color: '#fff',
      overflow: 'hidden'
    }}>
      
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transform: 'translate(-50%, -50%)',
          zIndex: 1
        }}
      >
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.55)',
        zIndex: 2
      }}></div>

      {/* 4. HERO CONTENT LAYER */}
      <div style={{ position: 'relative', zIndex: 3, maxWidth: '800px', padding: '0 20px' }}>
        <h1 style={{ fontSize: '58px', fontWeight: '800', marginBottom: '20px', lineHeight: '1.2', letterSpacing: '-1px' }}>
          Fresh Organic <br />
          <span style={{ color: '#22c55e' }}>Fruits & Vegetables</span>
        </h1>
        <p style={{ fontSize: '18px', color: '#e2e8f0', marginBottom: '40px', lineHeight: '1.6' }}>
          100% natural and chemical-free organic products directly from farms to your home.
        </p>

        {/* Buttons Row */}
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <Link to="/contact" style={{ textDecoration: 'none' }}>
            <button style={{
              backgroundColor: '#22c55e',
              color: '#fff',
              border: 'none',
              padding: '14px 36px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '8px',
              cursor: 'pointer',
              boxShadow: '0 4px 14px rgb(34 197 94 / 0.4)',
              transition: 'background-color 0.2s'
            }}>
              Shop Now
            </button>
          </Link>

          <button style={{
            backgroundColor: 'transparent',
            color: '#fff',
            border: '2px solid #fff',
            padding: '14px 36px',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '8px',
            cursor: 'pointer'
          }}>
            Explore More
          </button>
        </div>

      </div>
    </div>
  );
}

export default HeroSection;